import { AxiosError } from 'axios';
import Swal from 'sweetalert2';

import { clearDataAuthenticate } from '@/context/AuthenticateContext';
import { INITIAL_PATH } from '@/constants';

export const renderVersion = () => {
  console.info(
    '%c🚀 %cVersion 1.0.15',
    'color: #fff; font-weight: bold; background: #CD2C1F; padding: 4px; border-radius: 4px 0 0 4px',
    'color: #CD2C1F; font-weight: bold; background: #FFF; padding: 4px; padding-inline: 8px; border-radius: 0 4px 4px 0',
  );
};

interface IHasChangedPayload<T> {
  prev: T;
  current: T;
  watchParams?: (keyof T)[];
}

export const hasChanged = <T>({ prev, current, watchParams = [] }: IHasChangedPayload<T>) => {
  if (!!watchParams.length) {
    return watchParams.some((param) => prev[param] !== current[param]);
  }
  // @ts-ignore
  return Object.keys(prev).some((key) => prev[key] !== current[key]);
};

const exceptURLS = ['/login', '/change-password'];

export const navigateToLogin = (error: any) => {
  try {
    const { config } = error;
    if (config) {
      if (!exceptURLS.includes(config.url)) {
        if (error.response?.status == 401) {
          clearDataAuthenticate();
          window.location.href = `${INITIAL_PATH}/sign-in`;
        }
      }
    } else {
      if (!exceptURLS.includes(config.url)) {
        if (error.response?.status == 401) {
          clearDataAuthenticate();
          window.location.href = `${INITIAL_PATH}/sign-in`;
        }
      }
    }
  } catch (error) {}
};

export const handleError500 = (error: any) => {
  if (error instanceof AxiosError) {
    if (error.code === 'ERR_NETWORK') {
      const styled = `font-size: 13px`;
      Swal.fire({
        icon: 'error',
        title: 'Error',
        html: `
        <div>
          <p style="${styled}">An error has occurred, please try again later.</p>
          <p style="${styled}">You could try logging out and logging back in.</p>
        </div>
        `,
      });
    }
  }
};

export const customToFixed = (value: number | undefined, decimals = 3): number => {
  if (!value) return Number(Number(0.0).toFixed(decimals));
  return Number(value.toFixed(decimals));
};
